import { Box, useTheme } from "@mui/material";
import GenericAccordion from "@/modules/common/components/ui-kit/generic-accordion";
import TitleWithChildren from "@/modules/lead-page/new/components/sidebar/sections/title-with-children";
import {
  CampaignField,
  AdsetField,
  AdField,
} from "@/modules/lead-page/new/components/sidebar/fields";

const sectionFields = [
  {
    title: "Campaign",
    field: <CampaignField />,
  },
  {
    title: "Adset",
    field: <AdsetField />,
  },
  {
    title: "Ad",
    field: <AdField />,
  },
];

const CampaignSection = () => {
  const theme = useTheme();

  return (
    <GenericAccordion title="Campaign" id="campaign" defaultExpanded={true}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.md,
        }}
      >
        {sectionFields.map((field) => (
          <TitleWithChildren key={field.title} title={field.title}>
            {field.field}
          </TitleWithChildren>
        ))}
      </Box>
    </GenericAccordion>
  );
};

export default CampaignSection;
